export const financeQueryKeys = {
	financeAdmin: {
		dashboard: (clubId: string) => ["finance-admin", "clubs", clubId, "dashboard"] as const,
		invoices: (clubId: string, status?: string) =>
			["finance-admin", "clubs", clubId, "invoices", status ?? "all"] as const,
		membershipFees: (clubId: string) => ["finance-admin", "clubs", clubId, "fees"] as const,
		payments: (clubId: string) => ["finance-admin", "clubs", clubId, "payments"] as const,
	},
	mailing: {
		all: ["mailing"] as const,
		log: (id: string) => ["mailing", id] as const,
		logs: (params?: Record<string, unknown>) => ["mailing", "logs", params ?? {}] as const,
		preview: (key: string, locale: string) =>
			["mailing", "templates", key, "preview", locale] as const,
		stats: ["mailing", "stats"] as const,
		subscribers: (params?: Record<string, unknown>) =>
			["mailing", "subscribers", params ?? {}] as const,
		templates: ["mailing", "templates"] as const,
	},
} as const;
